import React, { useEffect, useState } from "react";
import Header from "../Core/Header";
import Footer from "../Core/Footer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { editPlan, setBus } from "../../redux/slices/bookingSlice";
import { motion } from "motion/react";
import Cookies from "js-cookie";
import {
  getBusDetails,
  searchBuses,
  searchCities,
} from "../../service/operations/api_methods";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "sonner";
import { baseURL, buses } from "../../service/api_endpoints";
import api from "../../service/api";
import { useMediaQuery } from "usehooks-ts";

const BusBooking = () => {
  const [mainModal, setMainModal] = useState(false);
  const [modalMode, setModalMode] = useState("pickup");
  const [seatNumber, setSeatNumber] = useState(0);
  const mobile = useMediaQuery("(max-width: 767px)");
  const [filterModal, setFilterModal] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const plan = useSelector((state) => state.booking.plan);
  const token = Cookies.get("roam-token");

  const inputRef = React.useRef(null); // for getting date to search buses
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, []);

  const today = new Date().toISOString().split("T")[0];
  const [boarding, setBoarding] = useState(plan?.boarding || "");
  const [dropping, setDropping] = useState(plan?.dropping || "");
  const [time, setTime] = useState(plan?.time || today);
  const [rotated, setRotated] = useState(true);

  
  function SwitchButton() {
    return (
      <motion.div
        onClick={() => {
          setRotated(true);
          let v = boarding;
          setBoarding(dropping);
          setDropping(v);
        }}
        initial={{ rotate: 0 }}
        animate={{
          rotate: rotated ? 180 : 0,
          boxShadow: rotated
            ? `
            0px 0px 18px rgba(80,80,80,0.9),
            0px 0px 40px rgba(120,120,120,0.7),
            0px 10px 30px rgba(60,60,60,0.5)
          `
            : `
            0px 0px 12px rgba(120,120,120,0.6),
            0px 6px 20px rgba(90,90,90,0.45),
            inset 0px 0px 8px rgba(255,255,255,0.3)
          `,
        }}
        whileHover={{
          scale: 1.08,
        }}
        whileTap={{
          scale: 0.92,
        }}
        transition={{
          rotate: {
            duration: 0.65,
            ease: "easeInOut",
          },
          boxShadow: {
            duration: 0.4,
          },
        }}
        style={{
          width: "100%",
          height: "100%",
          borderRadius: "50%",
          background: "#f5f5f5",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          position: "relative",
          overflow: "hidden",
          padding: 3,
        }}
      >
        {/* Deep animated grey glow */}
        <motion.div
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.35, 0.75, 0.35],
          }}
          transition={{
            duration: 2.2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            background: "rgba(140,140,140,0.35)",
            filter: "blur(6px)",
            zIndex: 0,
          }}
        />

        <img
          src="/Assets/switch.png"
          alt="switch"
          style={{
            width: mobile ? "20px" : "32px",
            zIndex: 2,
            userSelect: "none",
            pointerEvents: "none",
            filter: "drop-shadow(0px 2px 4px rgba(80,80,80,0.6))",
          }}
        />
      </motion.div>
    );
  }

  const filterValues = [
    { bus: "Primo Bus", quantity: 8 },
    { bus: "AC", quantity: 3 },
    { bus: "Sleeper", quantity: 6 },
    { bus: "Single seats", quantity: 7 },
    { bus: "Seater", quantity: 9 },
    { bus: "NonAc", quantity: 12 },
    { bus: "Volvo AC", quantity: 8 },
    { bus: "Luxary Bus", quantity: 2 },
  ];
 

  const [selectedFilters, setSelectedFilters] = useState("AC");
  const [selectedCategory, setSelectedCategory] = useState("Sleeper");
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [selectedBackSeats, setSelectedBackSeats] = useState([]);
  const [boardingPoint, setBoardingPoint] = useState(null);
  const [droppingPoint, setDroppingPoint] = useState(null);
  const [tripType, setTripType] = useState("one");
  const [busSearchResults, setBusSearchResults] = useState([]);
  const [selectedBus, setSelectedBus] = useState(null);
  const [unAvailableSeats, setUnAvailableSeats] = useState([]);
  const [busSelectLoading, setBusSelectLoading] = useState(null);
  const [fromCity, setFromCity] = useState([]);
  const [destinationCity, setDestinationCity] = useState([]);

  const [serachKey, setSearchKey] = useState("");

  const TwoCrossTwo = ({ col }) => {
    return (
      <div style={{ display: "flex" }}>
        {[col, col + 1, col + 2, col + 3].map((i, ind) => (
          <div
            style={{
              padding: "6px",
              cursor: unAvailableSeats.find(
                (p) => Number(p.seatNumber.substring(1)) === i + 1,
              )
                ? "not-allowed"
                : "pointer",
              paddingRight: ind === 1 ? "4em" : "",
            }}
            onClick={() => handleSeatSelection(i + 1)}
          >
            <img
              src={`${selectedSeats.includes(i + 1) ? "/Assets/seat-2.png" : "/Assets/seat-1.png"}`}
              style={{ height: mobile ? "18px" : "30px" }}
            />
            <p style={{ fontSize: "8px", color: "gray" }}>
              ₹ {selectedBus.basePrice}
            </p>
          </div>
        ))}
      </div>
    );
  };

  const OneCrossTwo = ({ col }) => {
    return (
      <div style={{ display: "flex" }}>
        {[col, col + 1, col + 2].map((i, ind) => (
          <div
            style={{
              padding: "6px",
              cursor: unAvailableSeats.find(
                (p) => Number(p.seatNumber.substring(1)) === i + 1,
              )
                ? "not-allowed"
                : "pointer",
              paddingRight: ind === 0 ? "4em" : "",
            }}
            onClick={() => handleSeatSelection(i + 1)}
          >
            <img
              src={`${selectedSeats.includes(i + 1) ? "/Assets/seat-2.png" : "/Assets/seat-1.png"}`}
              style={{ height: mobile ? "18px" : "30px" }}
            />
            <p style={{ fontSize: "8px", color: "gray" }}>
              ₹ {selectedBus.basePrice}
            </p>
          </div>
        ))}
      </div>
    );
  };

  const OneCrossThree = ({ col }) => {
    return (
      <div style={{ display: "flex" }}>
        {[col, col + 1, col + 2, col + 3].map((i, ind) => (
          <div
            style={{
              padding: "6px",
              cursor: unAvailableSeats.find(
                (p) => Number(p.seatNumber.substring(1)) === i + 1,
              )
                ? "not-allowed"
                : "pointer",
              paddingRight: ind === 0 ? "4em" : "",
            }}
            onClick={() => handleSeatSelection(i + 1)}
          >
            <img
              src={`${selectedSeats.includes(i + 1) ? "/Assets/seat-2.png" : "/Assets/seat-1.png"}`}
              style={{ height: mobile ? "18px" : "30px" }}
            />
            <p style={{ fontSize: "8px", color: "gray" }}>
              ₹ {selectedBus.basePrice}
            </p>
          </div>
        ))}
      </div>
    );
  };

  const TwoCrossThree = ({ col }) => {
    return (
      <div style={{ display: "flex" }}>
        {[col, col + 1, col + 2, col + 3, col + 4].map((i, ind) => (
          <div
            style={{
              padding: "6px",
              cursor: unAvailableSeats.find(
                (p) => Number(p.seatNumber.substring(1)) === i + 1,
              )
                ? "not-allowed"
                : "pointer",
              paddingRight: ind === 1 ? "4em" : "",
            }}
            onClick={() => handleSeatSelection(i + 1)}
          >
            <img
              src={`${selectedSeats.includes(i + 1) ? "/Assets/seat-2.png" : "/Assets/seat-1.png"}`}
              style={{ height: mobile ? "18px" : "30px" }}
            />
            <p style={{ fontSize: "8px", color: "gray" }}>
              ₹ {selectedBus.basePrice}
            </p>
          </div>
        ))}
      </div>
    );
  };

  const handleSearch = async () => {
    const data = {
      boarding,
      dropping,
      time,
    };
    dispatch(editPlan(data));
  };

  // safe, immutable, and uses latest state
  const handleFiltering = (item) => {
    setSelectedFilters(item);
  };

  const handleCategoryFiltering = (item) => {
    setSelectedCategory(item);
  };

  const handleSeatSelection = (item) => {
    if (
      unAvailableSeats.find((i) => Number(i.seatNumber.substring(1)) === item)
    ) {
      toast.error("not available");
      return;
    }
    setSelectedSeats((prev) => {
      const newList = prev.includes(item)
        ? prev.filter((i) => i !== item)
        : [...prev, item];
      console.log("updated list:", newList);
      return newList;
    });
  };

  const handleBackSeatSelection = (item) => {
    setSelectedBackSeats((prev) => {
      const newList = prev.includes(item)
        ? prev.filter((i) => i !== item)
        : [...prev, item];
      console.log("updated list:", newList);
      return newList;
    });
  };

  const handleBusSearch = async () => {
    let data = {
      from: boarding,
      to: dropping,
      date: time,

      token: token,
    };
    setSearchLoading(true);

    try {
      const response = await searchBuses(data);
      if (response.status === 200) {
        setBusSearchResults(response.data.data);
      }

      console.log(response);
    } catch (error) {
      console.log(error);
      setBusSearchResults([]);
    } finally {
      setSearchLoading(false);
    }
  };

  const handleBusSearchByName = async (key) => {
    setSearchKey(key);
    if (key === "") {
      return;
    }

    setSearchLoading(true);

    try {
      const response = await api.get(`${buses.SEARCH_BUSES}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          busName: key,
          date: time,
        },
      });
      if (response.status === 200) {
        setBusSearchResults(response.data.data);
      }

      console.log(response);
    } catch (error) {
      console.log(error);
      setBusSearchResults(["f", "h"]);
    } finally {
      setSearchLoading(false);
    }
  };

  const truncateToWords = (text, limit = 20) => {
    if (typeof text !== "string") return "";

    const words = text.trim().split(/\s+/);

    if (words.length <= limit) {
      return words.join(" ");
    }

    return words.slice(0, limit).join(" ") + " ...";
  };

  const handelBusDetails = async (id, timeSlot) => {
    setBusSelectLoading(id);
    try {
      let params = {
        from: boarding,
        to: dropping,
        date: time,
        timeSlot: JSON.stringify(timeSlot),
      };
      console.log("params", params);

      const response = await getBusDetails({ id: id, token: token, params });
      console.log("bus detail", response);
      if (!response.data.bus) {
        toast.error("Failed to get Bus details");
        return;
      }
      if (response.status === 200) {
        let busData = response?.data?.bus;
        if (
          busData.routes[0].additionalBoardingPoints.every(
            (route) => route.city !== boarding,
          )
        ) {
          console.log("route mismatch, so modifingg");
          var temp = busData.routes[0];
          busData.routes[0] = response?.data?.bus.routes[1];
          busData.routes[1] = temp;
        }

        const updatedBus = {
          ...busData, // spread existing fields
          unAvailableSeats,
        };
        setSelectedBus(updatedBus);
        dispatch(setBus(updatedBus));
              navigate("/bus-details");
      }

    } catch (error) {
      console.log(error);
      toast.error("Failed to get Bus details");
      return;
    } finally {
      setBusSelectLoading(null);

      // setMainModal(true)
    }
  };

  const handleConfirmBooking = async () => {
    if (!boardingPoint || !droppingPoint) {
      toast.info("Please select boarding and dropping points");
      return;
    }
    if (selectedSeats.length + selectedBackSeats.length === 0) {
      toast.info("Please select at least one seat to proceed");
      return;
    }

    let data = {
      boardingPoint,
      droppingPoint,
      seatNumbers: JSON.stringify(selectedSeats),
      backSeatNumbers: JSON.stringify(selectedBackSeats),
      selectedBus: selectedBus,
    };
    console.log("booking data", data);
    await localStorage.setItem("roam-booking", JSON.stringify(data));
    navigate("/payment");
  };

  useEffect(() => {
    handleBusSearch();
  }, [plan]);

  useEffect(() => {
    const abc = () => {
      if (selectedBus) {
        const result =
          selectedBus.routes[0]?.seats.filter(
            (item) => item.isAvailable === false,
          ) || [];
        const result2 =
          selectedBus?.routes[1]?.seats.filter(
            (item) => item.isAvailable === false,
          ) || [];
        setUnAvailableSeats([...result, ...result2]);
        console.log("not available", result, result2);
      }
    };
    abc();
  }, [selectedBus]);

  const handleCitysearch = async ({ query, from }) => {
    if (!query || !from) {
      return;
    }
    try {
      let data = {
        query,
        from,
        token,
      };
      console.log(data);

      const response = await searchCities(data);
      console.log(response);
      if (response.status === 200) {
        if (from === "from") {
          setFromCity(response.data.cities);
        } else {
          setDestinationCity(response.data.cities);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const controlHeader = () => {
    if (typeof window !== "undefined") {
      if (window.scrollY > lastScrollY && window.scrollY > 80) {
        // scrolling down
        setShowHeader(false);
      } else {
        // scrolling up
        setShowHeader(true);
      }
      setLastScrollY(window.scrollY);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", controlHeader);
    return () => {
      window.removeEventListener("scroll", controlHeader);
    };
  }, [lastScrollY]);

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: showHeader ? "0" : "-80px", // hide smoothly
          left: 0,
          right: 0,
          transition: "top 0.3s ease-in-out",
          zIndex: 1000,
          borderBottom: "1px solid rgba(255,255,255,0.2)",
          backdropFilter: "blur(10px)", // blur background
          background: "rgba(255, 255, 255, 0.3)", // transparent glass
          WebkitBackdropFilter: "blur(10px)", // for Safari
        }}
      >
        <Header />
      </div>

      <div
        style={{
          backgroundColor:
            mainModal || filterModal ? "rgba(255, 255, 255, 0.2)" : "white",
          backdropFilter: mainModal || filterModal ? "blur(4px)" : "none",
          filter: mainModal || filterModal ? "blur(4px)" : "none",
          paddingTop: showHeader ? "0px" : "0px",

          transition: "backdrop-filter 0.3s ease", // smooth transition
        }}
      >
        <div
          style={{
            width: "100%",
            boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "230px",
            zIndex: 600,
            backgroundImage: "url('/Sliding/newyork-img.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {mobile ? (
            <motion.div
              initial={{ y: -50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{
                duration: 1.5,
                ease: "easeOut",
              }}
              style={{
                position: "absolute",
                top: "120px",
                padding: "5px 10px",
                background: "rgba(255, 255, 255, 0.1)",
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                maxWidth: "99vw",
                minWidth: "99vw",
              }}
            >
              <div
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  border: "1px solid gray",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "white",
                }}
              >
                <div
                  style={{
                    width: "70%",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    backgroundColor: "white",
                    padding: "10px",
                    gap: "10px",
                  }}
                >
                  <img src="/Sliding/search.png" style={{ width: "20px" }} />
                  <input
                    style={{ width: "100%", border: "none", outline: "none" }}
                    placeholder="Search Bus by Bus Name...."
                    value={serachKey}
                    onChange={(e) => handleBusSearchByName(e.target.value)}
                  />
                </div>
                <div style={{ padding: "2px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <img
                      src="/Assets/calendar.png"
                      style={{ width: "10px", height: "10px" }}
                    />
                    <div>
                      <p
                        style={{
                          fontWeight: "700",
                          color: "gray",
                          fontSize: "8px",
                        }}
                      >
                        Date of Journey
                      </p>
                      <input
                        style={{
                          fontSize: "12px",
                          fontWeight: "700",
                          outline: "none",
                          border: "none",
                          backgroundColor: "transparent",
                          maxWidth: "70px",
                        }}
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                        ref={inputRef}
                        onClick={() => inputRef.current.showPicker()}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  border: "1px solid gray",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "white",
                }}
              >
                <div style={{ padding: "5px ", position: "relative" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      position: "relative",
                    }}
                  >
                    <img
                      src="/Assets/bus-entry.png"
                      style={{ width: "15px", height: "15px" }}
                    />
                    <div>
                      <p
                        style={{
                          fontWeight: "700",
                          color: "gray",
                          fontSize: "8px",
                        }}
                      >
                        from
                      </p>
                      <input
                        style={{
                          fontSize: "12px",
                          fontWeight: "700",
                          outline: "none",
                          border: "none",
                          maxWidth: "100px",
                        }}
                        value={boarding}
                        onChange={(e) => {
                          setBoarding(e.target.value);
                          handleCitysearch({
                            query: e.target.value,
                            from: "from",
                          });
                        }}
                      />
                    </div>
                    {fromCity.length > 0 && (
                      <div
                        className="hide-scrollbar"
                        style={{
                          position: "absolute",
                          zIndex: 1000,
                          backgroundColor: "#acaaaaff",
                          height: "fit-content",
                          padding: "2px",
                          borderRadius: "10px",
                          left: 0,
                          top: "40px",
                          width: "100px",
                          overflowY: "auto",
                        }}
                      >
                        {fromCity.map((item) => (
                          <div
                            style={{
                              borderRadius: "5px",
                              padding: "3px",
                              border: "0.3px solid grey",
                              backgroundColor: "white",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setBoarding(item.name);
                              setFromCity([]);
                            }}
                          >
                            <p
                              style={{
                                fontSize: "12px",
                                fontWeight: "700",
                                color: "#3a3939ff",
                              }}
                            >
                              {item.name}
                            </p>
                            <p
                              style={{
                                fontSize: "8px",
                                fontWeight: "600",
                                color: "#616161ff",
                              }}
                            >
                              {item.state}
                            </p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <SwitchButton />
                </div>
                <div
                  style={{
                    padding: "5px ",
                    position: "relative",
                    paddingLeft: "26px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      position: "relative",
                    }}
                  >
                    <img
                      src="/Assets/bus-exit.png"
                      style={{ width: "15px", height: "15px" }}
                    />
                    <div>
                      <p
                        style={{
                          fontWeight: "700",
                          color: "gray",
                          fontSize: "8px",
                        }}
                      >
                        to
                      </p>
                      <input
                        style={{
                          fontSize: "12px",
                          fontWeight: "700",
                          outline: "none",
                          border: "none",
                          maxWidth: "100px",
                        }}
                        value={dropping}
                        onChange={(e) => {
                          setDropping(e.target.value);
                          handleCitysearch({
                            query: e.target.value,
                            from: "to",
                          });
                        }}
                      />
                    </div>{" "}
                    {destinationCity.length > 0 && (
                      <div
                        className="hide-scrollbar"
                        style={{
                          position: "absolute",
                          zIndex: 1000,
                          backgroundColor: "#acaaaaff",
                          height: "fit-content",
                          padding: "2px",
                          borderRadius: "10px",
                          left: 0,
                          top: "40px",
                          width: "100px",
                          overflowY: "auto",
                        }}
                      >
                        {destinationCity.map((item) => (
                          <div
                            style={{
                              borderRadius: "5px",
                              padding: "3px",
                              border: "0.3px solid grey",
                              backgroundColor: "white",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setDropping(item.name);
                              setDestinationCity([]);
                            }}
                          >
                            <p
                              style={{
                                fontSize: "12px",
                                fontWeight: "700",
                                color: "#3a3939ff",
                              }}
                            >
                              {item.name}
                            </p>
                            <p
                              style={{
                                fontSize: "8px",
                                fontWeight: "600",
                                color: "#616161ff",
                              }}
                            >
                              {item.state}
                            </p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <motion.div
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                style={{
                  marginTop: "8px",
                  cursor: "pointer",
                  padding: "5px 30px",
                  backgroundColor: "#c4c4c4ff",
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                  borderRadius: "10px",
                }}
                onClick={handleSearch}
              >
                {/* <img src='/Assets/search.png' style={{width:"14px",height:"14px"}}/> */}
                <p
                  style={{ fontSize: "14px", color: "#000", fontWeight: "500" }}
                >
                  Search
                </p>
              </motion.div>
            </motion.div>
          ) : (
            <motion.div
              initial={{ y: -50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{
                duration: 1.5,
                ease: "easeOut",
              }}
              style={{
                position: "absolute",
                marginTop: "90px",
                padding: "18px 20px",
                background: "rgba(255, 255, 255, 0.1)",
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                boxShadow: "0 0 20px 5px rgba(255, 255, 255, 0.4)",
                zIndex: 99,
              }}
            >
              <div
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  border: "1px solid gray",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "white",
                  padding: "10px",
                  gap: "30px",
                }}
              >
                <img src="/Sliding/search.png" style={{ width: "20px" }} />
                <input
                  style={{ width: "100%", border: "none", outline: "none" }}
                  placeholder="Search Bus by Bus Name...."
                  value={serachKey}
                  onChange={(e) => handleBusSearchByName(e.target.value)}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  border: "1px solid gray",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "white",
                }}
              >
                <div style={{ padding: "5px 16px ", position: "relative" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <img
                      src="/Assets/bus-entry.png"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <div>
                      <p
                        style={{
                          fontWeight: "700",
                          color: "gray",
                          fontSize: "14px",
                        }}
                      >
                        from
                      </p>
                      <input
                        style={{
                          fontSize: "18px",
                          fontWeight: "700",
                          outline: "none",
                          border: "none",
                        }}
                        value={boarding}
                        onChange={(e) => {
                          setBoarding(e.target.value);
                          handleCitysearch({
                            query: e.target.value,
                            from: "from",
                          });
                        }}
                      />
                    </div>
                    {fromCity.length > 0 && (
                      <div
                        className="hide-scrollbar"
                        style={{
                          position: "absolute",
                          backgroundColor: "rgb(231, 229, 229)",
                          height: "fit-content",
                          padding: "3px",
                          borderRadius: "6px",
                          left: 0,
                          top: "50px",
                          width: "100%",
                          overflowY: "auto",
                        }}
                      >
                        {fromCity.map((item) => (
                          <div
                            style={{
                              borderRadius: "8px",
                              padding: "5px",
                              border: "0.3px solid grey",
                              backgroundColor: "white",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setBoarding(item.name);
                              setFromCity([]);
                            }}
                          >
                            <p
                              style={{
                                fontSize: "15px",
                                fontWeight: "700",
                                color: "rgb(83, 83, 83)",
                              }}
                            >
                              {item.name}
                            </p>
                            <p
                              style={{
                                fontSize: "10px",
                                fontWeight: "600",
                                color: "#616161ff",
                              }}
                            >
                              {item.state}
                            </p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <SwitchButton />
                </div>

                <div
                  style={{
                    padding: "5px 16px",
                    position: "relative",
                    paddingLeft: "26px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <img
                      src="/Assets/bus-exit.png"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <div>
                      <p
                        style={{
                          fontWeight: "700",
                          color: "gray",
                          fontSize: "14px",
                        }}
                      >
                        to
                      </p>
                      <input
                        style={{
                          fontSize: "18px",
                          fontWeight: "700",
                          outline: "none",
                          border: "none",
                        }}
                        value={dropping}
                        onChange={(e) => {
                          setDropping(e.target.value);
                          handleCitysearch({
                            query: e.target.value,
                            from: "to",
                          });
                        }}
                      />
                    </div>
                    {destinationCity.length > 0 && (
                      <div
                        className="hide-scrollbar"
                        style={{
                          position: "absolute",
                          zIndex: 999,
                          backgroundColor: "rgb(231, 229, 229)",
                          height: "fit-content",
                          padding: "3px",
                          borderRadius: "6px",
                          left: 0,
                          top: "52px",
                          width: "100%",
                          overflowY: "auto",
                        }}
                      >
                        {destinationCity.map((item) => (
                          <div
                            style={{
                              borderRadius: "8px",
                              padding: "5px",
                              border: "0.3px solid grey",
                              backgroundColor: "white",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setDropping(item.name);
                              setDestinationCity([]);
                            }}
                          >
                            <p
                              style={{
                                fontSize: "15px",
                                fontWeight: "700",
                                color: "rgb(105, 104, 104)",
                              }}
                            >
                              {item.name}
                            </p>
                            <p
                              style={{
                                fontSize: "10px",
                                fontWeight: "600",
                                color: "#616161ff",
                              }}
                            >
                              {item.state}
                            </p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div
                  style={{ padding: "5px 16px", borderLeft: "1px solid gray" }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <div>
                      <p
                        style={{
                          fontWeight: "700",
                          color: "gray",
                          fontSize: "14px",
                        }}
                      >
                        Date of Journey
                      </p>
                      <input
                        style={{
                          fontSize: "18px",
                          fontWeight: "700",
                          outline: "none",
                          border: "none",
                          backgroundColor: "transparent",
                          width: "fit-content",
                          textTransform: "uppercase",
                        }}
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                        type="date"
                        ref={inputRef}
                        onClick={() => inputRef.current.showPicker()}
                        min={today}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* // search button */}
              <motion.div
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                style={{
                  position: "absolute",
                  marginTop: "100px",
                  zIndex: 90,
                  cursor: "pointer",
                  padding: "10px 30px",
                  backgroundColor: "#222745",
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                  borderRadius: "16px",
                }}
                onClick={handleSearch}
              >
                <img
                  src="/Sliding/search.png"
                  style={{ width: "20px", height: "20px" }}
                />
                <p
                  style={{
                    fontSize: "18px",
                    color: "white",
                    fontWeight: "500",
                  }}
                >
                  Search buses
                </p>
              </motion.div>
            </motion.div>
          )}
        </div>

        <div
          style={{
            display: "flex",
            width: "100%",
            paddingLeft: "5%",
            paddingRight: "5%",
            paddingTop: mobile ? "10px" : "40px",
            background:
              "linear-gradient(360deg, #ffffffff, rgb(250, 250, 250), rgb(245, 244, 244))",
          }}
        >
          {!mobile && (
            <motion.div
              initial={{ x: -100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{
                duration: 1.2,
                ease: "easeOut",
              }}
              style={{
                minHeight: "500px",
                width: "20%",
                backgroundColor: "#ffffffff",
                borderRadius: "10px",
                margin: "8px",
                padding: "8px",
                boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                overflowY: "auto",
                maxHeight: "65vh",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                position: "sticky",
                overflow: "hidden",
              }}
            >
              <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "125%",
                  objectFit: "cover",
                  zIndex: 0,
                }}
              >
                <source src="/Sliding/vid-2.mp4" type="video/mp4" />
              </video>
            </motion.div>
          )}

          {mobile ? (
            <div
              style={{
                height: "80%",
                width: "100%",
                backgroundColor: "#ffffffff",
                borderRadius: "10px",
                margin: "0px",
              }}
            >
              <div
                style={{
                  padding: "8px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  maxHeight: "65vh",
                  overflowY: "auto",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                {searchLoading ? (
                  <div style={{ width: "100%", height: "50%" }}>
                    <Box sx={{ width: "100%" }}>
                      <LinearProgress />
                    </Box>
                  </div>
                ) : (
                  <div
                    style={{
                      padding: "8px",
                      background: "transparent",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      maxHeight: "70vh",
                      borderRadius: "10px",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    {busSearchResults.length > 0 ? (
                      busSearchResults.map((item) => (
                        <motion.div
                          initial={{ x: 100, opacity: 0 }}
                          whileInView={{ x: 0, opacity: 1 }}
                          transition={{ duration: 0.4, ease: "easeOut" }}
                          viewport={{ once: false, amount: 0.3 }}
                          className="card"
                          style={{
                            borderRadius: "10px",
                            backgroundColor: "#ffffff",
                            padding: "12px",
                            border: "0.3px solid rgba(235, 235, 235, 0.93)fe",
                            boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "start",
                              padding: "12px 0px",
                            }}
                          >
                            <div>
                              <p
                                style={{ fontSize: "20px", fontWeight: "700" }}
                              >
                                {item.bus?.primaryImage ? (
                                  <img
                                    src={`https://admin.roamjssln.com${item?.bus?.primaryImage}`}
                                    style={{ width: "30px", height: "30px" }}
                                  />
                                ) : (
                                  <img
                                    src="/Assets/bus_10.png"
                                    style={{ width: "30px", height: "30px" }}
                                  />
                                )}
                              </p>
                            </div>

                            <div>
                              <p
                                style={{ fontSize: "14px", fontWeight: "700" }}
                              >
                                {item.bus?.busName}
                              </p>
                              <p
                                style={{
                                  fontSize: "10px",
                                  fontWeight: "400",
                                  color: "gray",
                                }}
                              >
                                {item.bus?.busNumber} ({item.bus?.busType}/
                                {item.bus?.busCategory})
                              </p>
                            </div>

                            <div>
                              <p
                                style={{ fontSize: "12px", fontWeight: "600" }}
                              >
                                {
                                  item.routes[0].additionalBoardingPoints[0]
                                    ?.pickupTime
                                }{" "}
                                -{" "}
                                {
                                  item.routes[0].additionalDroppingPoints[0]
                                    ?.dropTime
                                }
                              </p>
                              {/* <p style={{fontSize:"8px",fontWeight:"400",color:"black"}}>{item.route?.additionalBoardingPoints[1]?.pickupTime} - {item.route?.additionalDroppingPoints[1]?.dropTime}</p> */}
                              <p
                                style={{
                                  fontSize: "8px",
                                  fontWeight: "400",
                                  color: "gray",
                                }}
                              >
                                {
                                  item.routes[0].routeDetails.estimatedDuration
                                    .hours
                                }{" "}
                                hrs{" "}
                                {
                                  item.routes[0].routeDetails.estimatedDuration
                                    .minutes
                                }{" "}
                                mins
                              </p>
                            </div>
                            <div>
                              <p
                                style={{ fontSize: "12px", fontWeight: "700" }}
                              >
                                ₹{item.routes[0].fare}/-
                              </p>
                              <p
                                style={{
                                  fontSize: "10px",
                                  fontWeight: "400",
                                  color: "#2f92c4",
                                }}
                              >
                                {item.availableSeats} Seats left of{" "}
                                {item.bus?.totalSeats}
                              </p>
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              width: "100%",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                width: "20%",
                                justifyContent: "start",
                                gap: "2px",
                              }}
                            >
                              <div>
                                <p
                                  style={{
                                    fontSize: "20px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {item?.bus?.images &&
                                  item?.bus?.images.length > 0 ? (
                                    <>
                                      {item?.bus?.images.slice(0, 2).map((i) => (
                                        <img
                                          src={`https://admin.roamjssln.com${i}`}
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                          }}
                                        />
                                      ))}
                                    </>
                                  ) : (
                                    <img
                                      src="/Assets/bus_10.png"
                                      style={{ width: "30px", height: "30px" }}
                                    />
                                  )}
                                </p>
                              </div>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                width: "80%",
                                justifyContent: "space-between",
                              }}
                            >
                              <div>
                                <p
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    padding: "3px",
                                    borderRadius: "4px",
                                    border: "0.3px solid rgb(16, 168, 245)",
                                    backgroundColor: "",
                                    width: "fit-content",
                                    color: "black",
                                  }}
                                >
                                  <img
                                    src="/Assets/star.png"
                                    style={{ width: "10px" }}
                                  />
                                  <span>
                                    {
                                      item.routes[0]
                                        ?.additionalBoardingPoints[0]?.city
                                    }
                                  </span>
                                </p>
                                <p
                                  style={{
                                    fontSize: "10px",
                                    fontWeight: "400",
                                    color: "gray",
                                  }}
                                >
                                  {
                                    item.routes[0]?.additionalBoardingPoints[0]
                                      ?.landmark
                                  }
                                </p>
                              </div>
                              <div>
                                <p
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    padding: "3px",
                                    borderRadius: "4px",
                                    border: "0.3px solid rgb(9, 252, 138)",
                                    backgroundColor: "",
                                    width: "fit-content",
                                    color: "black",
                                  }}
                                >
                                  <img
                                    src="/Assets/star.png"
                                    style={{ width: "10px" }}
                                  />
                                  <span>
                                    {
                                      item.routes[0]
                                        ?.additionalDroppingPoints[0]?.city
                                    }
                                  </span>
                                </p>
                                <p
                                  style={{
                                    fontSize: "10px",
                                    fontWeight: "400",
                                    color: "gray",
                                  }}
                                >
                                  {
                                    item.routes[0]?.additionalDroppingPoints[0]
                                      ?.landmark
                                  }
                                </p>
                              </div>
                            </div>
                          </div>

                          <div
                            style={{
                              borderTop: "1px solid gray",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "12px",
                              marginTop: "10px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                gap: "3px",
                                width: "40%",
                                flexWrap: "wrap",
                                fontSize: "8px",
                                color: "rgb(16, 168, 245)",
                                fontWeight: "400",
                              }}
                            >
                              {item.bus?.amenities?.map((i) => (
                                <p>{i}</p>
                              ))}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "10px",
                                justifyContent: "left",
                                fontSize: "8px",
                                fontWeight: 400,
                              }}
                            >
                              Via~{" "}
                              {item?.routes[0]?.via.length > 0
                                ? [0, 1].map((i) => (
                                    <p style={{ fontWeight: "bolder" }}>
                                      {item?.routes[0]?.via[i]?.city}
                                    </p>
                                  ))
                                : "Not Available"}
                            </div>

                            <p
                              onClick={() => handelBusDetails(item.bus?._id)}
                              style={{
                                fontSize: "10px",
                                fontWeight: "600",
                                color: "white",
                                borderRadius: "10px",
                                backgroundColor: "#3ba86e",
                                padding: "4px",
                                cursor: "pointer",
                              }}
                            >
                              {busSelectLoading === item.bus.id ? (
                                <Box sx={{ display: "flex" }}>
                                  <CircularProgress size={20} />
                                </Box>
                              ) : (
                                "Select Seats"
                              )}
                            </p>
                          </div>
                        </motion.div>
                      ))
                    ) : (
                      <div style={{ width: "70vw", height: "70vh", display:"flex",justifyContent:"center"}}>
                        <img
                          src="/Sliding/nobus.png"
                          style={{
                            contain: "cover",
                            width: "200%",
                            height: "70vh",
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div
              style={{
                height: "80%",
                width: "80%",
                backgroundColor: "#ffffffff",
                borderRadius: "10px",
                margin: "8px",
              }}
            >
              {searchLoading ? (
                <div style={{ width: "100%", height: "50%" }}>
                  <Box sx={{ width: "100%" }}>
                    <LinearProgress />
                  </Box>
                </div>
              ) : (
                <div
                  style={{
                    padding: "8px",
                    background: "transparent",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    maxHeight: "70vh",
                    borderRadius: "10px",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  {busSearchResults.length > 0 ? (
                    busSearchResults.map((item, ind) => (
                      <motion.div
                        initial={{ x: 100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        transition={{ duration: 1.2, ease: "easeOut" }}
                        viewport={{ once: false, amount: 0.3 }}
                        className="card"
                        style={{
                          borderRadius: "10px",
                          backgroundColor: "white",
                          padding: "12px",
                          border: "0.3px solid rgba(235, 235, 235, 0.93)fe",
                          boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                            padding: "12px 0px",
                            gap: "2px",
                          }}
                        >
                          <div>
                            <p style={{ fontSize: "20px", fontWeight: "700" }}>
                              {item.bus?.primaryImage ? (
                                <img
                                  src={`https://admin.roamjssln.com${item?.bus?.primaryImage}`}
                                  style={{
                                    width: "80px",
                                    height: "70px",
                                    borderRadius: "8px",
                                  }}
                                  alt="bus"
                                />
                              ) : (
                                <img
                                  src="/Assets/bus_10.png"
                                  style={{ width: "80px" }}
                                />
                              )}
                            </p>
                            <p
                              style={{
                                fontSize: "14px",
                                fontWeight: "400",
                                color: "gray",
                              }}
                            ></p>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "start",
                              padding: "2px 20px",
                              width: "85%",
                            }}
                          >
                            <div>
                              <p
                                style={{ fontSize: "20px", fontWeight: "600" }}
                              >
                                {truncateToWords(item.bus?.busName)}
                              </p>
                              <p
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "400",
                                  color: "gray",
                                }}
                              >
                                {item.bus?.busNumber} ({item.bus?.busType}/
                                {item.bus?.busCategory})
                              </p>
                            </div>

                            <div>
                              <p
                                style={{ fontSize: "15px", fontWeight: "600" }}
                              >
                                {item?.routes[0]?.journey?.departureTime} -{" "}
                                {item?.routes[0]?.journey?.arrivalTime}
                              </p>
                              {/* <p style={{fontSize:"10px",fontWeight:"400"}}>{item.route?.additionalBoardingPoints[1]?.pickupTime} - {item.route?.additionalDroppingPoints[1]?.dropTime}</p> */}
                              <p
                                style={{
                                  fontSize: "10px",
                                  fontWeight: "400",
                                  color: "gray",
                                }}
                              >
                                {
                                  item?.routes[0]?.routeDetails
                                    ?.estimatedDuration?.hours
                                }{" "}
                                hrs{" "}
                                {
                                  item?.routes[0]?.routeDetails
                                    ?.estimatedDuration?.minutes
                                }{" "}
                                mins
                              </p>
                            </div>
                            <div>
                              <p
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "600",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  color: "black",
                                }}
                              >
                                <span>₹ {item.routes[0]?.fare}/- </span>
                              </p>
                              {/* <p style={{fontSize:"12px",fontWeight:"600",display:"flex",justifyContent:"space-between",alignItems:"center",color:"#807f7f"}}>
                                  <span>Base ₹ {item.routes[1]?.fare}/- </span></p> */}
                              <p
                                style={{
                                  fontSize: "10px",
                                  fontWeight: "600",
                                  color: "#2f92c4",
                                }}
                              >
                                {item?.availableSeats} Seats left of{" "}
                                {item.bus?.totalSeats}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              width: "15%",
                              justifyContent: "start",
                              gap: "2px",
                            }}
                          >
                            {item.bus?.images &&
                              item.bus?.images.length > 0 &&
                              item.bus?.images
                                .slice(0, 2)
                                .map((img) => (
                                  <div>
                                    {item.bus?.images.length < 0 ? (
                                      <img
                                        src="/Assets/bus_10.png"
                                        style={{
                                          width: "30px",
                                          height: "30px",
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={`https://admin.roamjssln.com${img}`}
                                        style={{
                                          width: "30px",
                                          height: "30px",
                                        }}
                                      />
                                    )}
                                  </div>
                                ))}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "start",
                              padding: "2px 20px",
                              width: "85%",
                            }}
                          >
                            <div>
                              <p
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "600",
                                  padding: "3px 6px",
                                  borderRadius: "4px",
                                  border: "0.5px solid #37cece",
                                  width: "fit-content",
                                  color: "black",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <img
                                  src="/Assets/bus-ic.png"
                                  style={{ width: "20px" }}
                                />
                                <span>{item.routes[0]?.journey?.fromCity}</span>
                              </p>
                              <p
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "400",
                                  color: "gray",
                                }}
                              >
                                {" "}
                                <img
                                  src="/Assets/star.png"
                                  style={{ width: "10px" }}
                                />
                                <span>
                                  {
                                    item.routes[0]?.additionalBoardingPoints[0]
                                      ?.landmark
                                  }
                                </span>
                              </p>
                            </div>
                            <div>
                              <img
                                src="/Assets/switch.png"
                                style={{ width: "30px" }}
                              />
                            </div>
                            <div>
                              <p
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "600",
                                  padding: "3px 6px",
                                  borderRadius: "4px",
                                  border: "0.5px solid rgb(37, 255, 153)",
                                  backgroundColor: "",
                                  width: "fit-content",
                                  color: "black",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <img
                                  src="/Assets/bus-ic.png"
                                  style={{ width: "20px" }}
                                />
                                <span>{item.routes[0]?.journey?.toCity}</span>
                              </p>
                              <p
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "400",
                                  color: "gray",
                                }}
                              >
                                <img
                                  src="/Assets/star.png"
                                  style={{ width: "10px" }}
                                />
                                <span>
                                  {
                                    item.routes[0]?.additionalDroppingPoints[0]
                                      ?.landmark
                                  }
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            borderTop: "1px solid gray",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "5px",
                            marginTop: "10px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: "20px",
                              width: "40%",
                              flexWrap: "wrap",
                              fontSize: "10px",
                              color: "#37cece",
                              fontWeight: "700",
                            }}
                          >
                            {item.bus?.amenities?.map((i) => (
                              <p>{i}</p>
                            ))}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              justifyContent: "left",
                              fontSize: "14px",
                              fontWeight: 600,
                            }}
                          >
                            Via~{" "}
                            {item?.routes[0]?.via.length > 0
                              ? [0, 1].map((i) => (
                                  <p style={{ fontWeight: "bolder" }}>
                                    {item?.routes[0]?.via[i]?.city}
                                  </p>
                                ))
                              : "Not Available"}
                          </div>

                          <p
                            onClick={() =>
                              handelBusDetails(
                                item.bus?._id,
                                item?.routes[0]?.journey?.timeSlot,
                              )
                            }
                            style={{
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "white",
                              borderRadius: "10px",
                              backgroundColor:
                                item.routes[0].bookingStatus.bookingType ===
                                "completed"
                                  ? "#194096"
                                  : "#3ba86e",
                              padding: "10px",
                              cursor: "pointer",
                            }}
                          >
                            {busSelectLoading === item.bus._id ? (
                              <Box sx={{ display: "flex" }}>
                                <CircularProgress size={20} />
                              </Box>
                            ) : item.routes[0].bookingStatus.bookingType ===
                              "completed" ? (
                              "View Details"
                            ) : (
                              "Select Seats"
                            )}
                          </p>

                          {item.routes[0].bookingStatus.bookingType ===
                            "completed" && (
                            <p
                              style={{
                                fontSize: "12px",
                                fontWeight: "600",
                                color: "white",
                                borderRadius: "10px",
                                backgroundColor: "#454645",
                                padding: "10px",
                                cursor: "not-allowed",
                              }}
                            >
                              Completed
                            </p>
                          )}
                        </div>
                      </motion.div>
                    ))
                  ) : (
                    <div
                      style={{
                        width: "70vw",
                        height: "70vh",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src="/Sliding/nobus.png"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {filterModal && (
        <div
          style={{ position: "absolute", top: "20vw", left: 0, zIndex: 1100 }}
        >
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{
              duration: 1.2,
              ease: "easeOut",
            }}
            style={{
              minHeight: "40vh",
              width: "60%",
              backgroundColor: "#ffffffff",
              borderRadius: "10px",
              margin: "8px",
              padding: "8px",
              boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)",
            }}
          >
            <p
              style={{
                fontSize: "24px",
                fontWeight: "700",
                padding: "12px",
                borderBottom: "1px solid gray",
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <span>Filter Buses</span>

              <span
                style={{
                  fontSize: "10px",
                  cursor: "pointer",
                  padding: "5px",
                  borderRadius: "50%",
                  width: "15px",
                  height: "15px",
                }}
                onClick={() => setFilterModal(false)}
              >
                X
              </span>
            </p>

            <div
              style={{
                padding: "5px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              {selectedFilters && (
                <p
                  style={{
                    fontSize: "10px",
                    border: "0.3px solid #2f92c4",
                    borderRadius: "5px",
                    padding: "3px",
                    width: "80px",
                    height: "20px",
                    color: "black",
                    fontWeight: "600",
                    backgroundColor: "#9edbfaff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  {selectedFilters}
                  <span
                    style={{ fontSize: "8px", cursor: "pointer", color: "red" }}
                    onClick={() => {
                      setSelectedFilters("");
                    }}
                  >
                    X
                  </span>
                </p>
              )}

              {selectedCategory && (
                <p
                  style={{
                    fontSize: "10px",
                    border: "0.3px solid #2f92c4",
                    borderRadius: "5px",
                    padding: "3px",
                    width: "80px",
                    height: "20px",
                    color: "black",
                    fontWeight: "600",
                    backgroundColor: "#9edbfaff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  {selectedCategory}
                  <span
                    style={{ fontSize: "8px", cursor: "pointer", color: "red" }}
                    onClick={() => {
                      setSelectedCategory("");
                    }}
                  >
                    X
                  </span>
                </p>
              )}
            </div>
            <input
              style={{
                padding: "6px",
                borderRadius: "10px",
                margin: "10px",
                border: "0.3px solid gray",
                outline: "none",
              }}
              placeholder="Search"
            />

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                padding: "10px",
                gap: "8px",
              }}
            >
              {filterValues.map((item) => (
                <p
                  onClick={() => handleFiltering(item.bus)}
                  style={{
                    padding: "5px",
                    borderRadius: "8px",
                    border: "0.5px solid gray",
                    cursor: "pointer",
                    fontSize: "12px",
                    backgroundColor: selectedFilters.includes(item.bus)
                      ? "#b6b6b6ff"
                      : "transparent",
                    fontWeight: "700",
                  }}
                >
                  {item.bus} ({item.quantity})
                </p>
              ))}
            </div>
          </motion.div>
        </div>
      )}

      {mainModal && (
        <motion.div
          initial={{ y: 500, opacity: 1 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{
            duration: 0.4,
            ease: "easeIn",
          }}
          style={{
            boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
            position: "absolute",
            top: "150px",
            backgroundColor: "white",
            zIndex: 900,
            borderRadius: "15px",
            height: mobile ? "70vh" : "110%",
            width: "100%",
            minHeight: "fit-content",
          }}
        >
          {
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "40px",
                padding: "20px",
                borderBottom: "1px solid gray",
              }}
            >
              <p
                style={{ cursor: "pointer", fontSize: "22px" }}
                onClick={() => setMainModal(false)}
              >
                X
              </p>
              <p
                style={{
                  fontSize: mobile ? "15px" : "20px",
                  fontWeight: "700",
                }}
              >
                Select seats and locations
              </p>
            </div>
          }

          {mobile ? (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingLeft: "4%",
                paddingRight: "4%",
                height: "80%",
                width: "100%",
                background:
                  "linear-gradient(360deg, #ffffffff, #cac8c8ff, #c5c3c3ff)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "15px",
                  borderTopLeftRadius: "10px",
                  borderBottomLeftRadius: "10px",
                  background:
                    "linear-gradient(180deg, #ffffffff, #b9b9b9ff, #7e7d7dff)",
                  maxHeight: "100%",
                  overflowY: "auto",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  width: "50%",
                }}
              >
                <p
                  style={{
                    width: "100%",
                    fontSize: "12px",
                    fontWeight: "700",
                    padding: "10px",
                  }}
                >
                  Select Seats
                </p>
                <div
                  style={{
                    width: "150px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "4px",
                    padding: "3px",
                    borderRadius: "15px",
                    boxShadow: "0 0 10px 2px rgba(94, 36, 36, 0.3)",
                    backgroundColor: "#c5e9fdff",
                  }}
                >
                  {selectedBus.seatConfiguration.busType === "2*2" ? (
                    Array.from({
                      length: selectedBus.seatConfiguration?.rows || 0,
                    }).map((_, ind) => (
                      <TwoCrossTwo
                        col={ind * selectedBus.seatConfiguration?.columns}
                      />
                      //<OneCrossTwo start={item} end={item+selectedBus.seatConfiguration?.column}/>
                    ))
                  ) : selectedBus.seatConfiguration.busType === "1*2" ||
                    "2*1" ? (
                    Array.from({
                      length: selectedBus.seatConfiguration?.rows || 0,
                    }).map((_, ind) => (
                      <OneCrossTwo
                        col={ind * selectedBus.seatConfiguration?.columns}
                      />
                      //<OneCrossTwo start={item} end={item+selectedBus.seatConfiguration?.column}/>
                    ))
                  ) : selectedBus.seatConfiguration.busType === "3*2" ||
                    "2*3" ? (
                    Array.from({
                      length: selectedBus.seatConfiguration?.rows || 0,
                    }).map((_, ind) => (
                      <TwoCrossThree
                        col={ind * selectedBus.seatConfiguration?.columns}
                      />
                      //<OneCrossTwo start={item} end={item+selectedBus.seatConfiguration?.column}/>
                    ))
                  ) : selectedBus.seatConfiguration.busType === "1*3" ||
                    "3*1" ? (
                    Array.from({
                      length: selectedBus.seatConfiguration?.rows || 0,
                    }).map((_, ind) => (
                      <OneCrossThree
                        col={ind * selectedBus.seatConfiguration?.columns}
                      />
                      //<OneCrossTwo start={item} end={item+selectedBus.seatConfiguration?.column}/>
                    ))
                  ) : (
                    <div>No seat configuration available</div>
                  )}

                  <div style={{ display: "flex" }}>
                    {Array.from({
                      length: selectedBus.seatConfiguration.back,
                    }).map((_, index) => (
                      <div
                        style={{ padding: "6px", cursor: "pointer" }}
                        onClick={() => handleBackSeatSelection(index + 1)}
                      >
                        <img
                          src={`${selectedBackSeats.includes(index + 1) ? "/Assets/seat-2.png" : "/Assets/seat-1.png"}`}
                        />
                        <p style={{ fontSize: "8px", color: "gray" }}>₹ 150</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div
                style={{
                  background:
                    "linear-gradient(180deg, #ffffffff, #b9b9b9ff, #7e7d7dff)",
                  minHeight: "100%",
                  borderLeft: "1px solid gray",
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  gap: "10px",
                  borderTopRightRadius: "10px",
                  borderBottomRightRadius: "10px",
                }}
              >
                <div>
                  <div
                    style={{
                      borderBottom: "0.4px solid gray",
                      cursor: "pointer",
                    }}
                  >
                    <p
                      onClick={() => {
                        modalMode === "routes"
                          ? setModalMode("")
                          : setModalMode("routes");
                      }}
                      style={{
                        fontSize: "15px",
                        padding: "10px",
                        fontWeight: "700",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>Show Routes</span>
                      <span>
                        {modalMode === "routes" ? (
                          <img
                            src="/Assets/arrow-up.png"
                            style={{ width: "20px" }}
                          />
                        ) : (
                          <img
                            src="/Assets/down-arrow.png"
                            style={{ width: "20px" }}
                          />
                        )}
                      </span>
                    </p>
                    {/* {
                  modalMode==="routes" && 
                  <div style={{display:"flex",flexDirection:"column",maxHeight:"200px",overflowY:"auto",scrollbarWidth: "none", msOverflowStyle: "none",padding:"10px"}}>
                    {routesPoints.map((item)=>(
                      <p style={{display:'flex',justifyContent:"space-between",paddingBottom:"16px",fontWeight:"300",paddingLeft:"20px"}}>
                        <span style={{width:"10px",height:"10px",borderRadius:"50%",backgroundColor:"#25faa8ff"}}></span>
                        <span>{item.point}</span><span>{item.time}</span></p>
                    ))

                    }

                  </div>
                } */}
                  </div>
                  <div
                    style={{
                      borderBottom: "0.4px solid gray",
                      cursor: "pointer",
                    }}
                  >
                    <p
                      onClick={() => {
                        modalMode === "pickup"
                          ? setModalMode("")
                          : setModalMode("pickup");
                      }}
                      style={{
                        fontSize: "15px",
                        padding: "10px",
                        fontWeight: "700",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>Select Pickup-points</span>
                      <span>
                        {modalMode === "pickup" ? (
                          <img
                            src="/Assets/arrow-up.png"
                            style={{ width: "20px" }}
                          />
                        ) : (
                          <img
                            src="/Assets/down-arrow.png"
                            style={{ width: "20px" }}
                          />
                        )}
                      </span>
                    </p>
                    {modalMode === "pickup" && (
                      <div
                        style={{
                          padding: "10px",
                          border: "0.4px solid gray",
                          borderRadius: "10px",
                          margin: "12px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                        }}
                      >
                        <p style={{ fontWeight: "600" }}>Pickup Points</p>

                        {selectedBus.route?.additionalBoardingPoints.map(
                          (i) => (
                            <div
                              onClick={() => setBoardingPoint(i._id)}
                              style={{
                                padding: "8px",
                                width: "70%",
                                height: "80px",
                                borderBottom: "0.3px solid gray",
                                fontSize: "8px",
                                backgroundColor:
                                  boardingPoint === i._id
                                    ? "#adf8e2ff"
                                    : "white",
                                borderRadius: "10px",
                              }}
                            >
                              <p>{i.name}</p>
                              <p>{i.pickupTime}</p>
                              <p>{i.address}</p>
                              <p>{i.city}</p>
                            </div>
                          ),
                        )}
                      </div>
                    )}
                  </div>

                  <div style={{ cursor: "pointer" }}>
                    <p
                      onClick={() => {
                        modalMode === "dropping"
                          ? setModalMode("")
                          : setModalMode("dropping");
                      }}
                      style={{
                        fontSize: "15px",
                        padding: "10px",
                        fontWeight: "700",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>Select Drop-points</span>
                      <span>
                        {modalMode === "dropping" ? (
                          <img
                            src="/Assets/arrow-up.png"
                            style={{ width: "20px" }}
                          />
                        ) : (
                          <img
                            src="/Assets/down-arrow.png"
                            style={{ width: "20px" }}
                          />
                        )}
                      </span>
                    </p>
                    {modalMode === "dropping" && (
                      <div
                        style={{
                          padding: "10px",
                          border: "0.4px solid gray",
                          borderRadius: "10px",
                          margin: "12px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                        }}
                      >
                        <p style={{ fontWeight: "600" }}>Dropping Points</p>

                        {selectedBus.route?.additionalDroppingPoints.map(
                          (i) => (
                            <div
                              onClick={() => setDroppingPoint(i._id)}
                              style={{
                                padding: "8px",
                                width: "70%",
                                height: "80px",
                                borderBottom: "0.3px solid gray",
                                fontSize: "8px",
                                backgroundColor:
                                  droppingPoint === i._id
                                    ? "#adf8e2ff"
                                    : "white",
                                borderRadius: "10px",
                              }}
                            >
                              <p>{i.name}</p>
                              <p>{i.dropTime}</p>
                              <p>{i.address}</p>
                              <p>{i.city}</p>
                            </div>
                          ),
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div
                  style={{
                    padding: "5px",
                    borderRadius: "10px",
                    margin: "2px",
                    backgroundColor: "white",
                    borderBottom: "1px solid grey",
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>
                      <p style={{ fontWeight: "700" }}>Selected Seats</p>
                      <p>{selectedSeats.length + selectedBackSeats.length}</p>
                    </div>
                    <div>
                      <p>
                        {selectedBus.basePrice *
                          (selectedSeats.length +
                            selectedBackSeats.length)}{" "}
                        /-
                      </p>
                      <p style={{ color: "#489dbeff", fontWeight: "700" }}>
                        Fare Details
                      </p>
                    </div>
                  </div>
                  <p
                    onClick={handleConfirmBooking}
                    style={{
                      width: "100%",
                      backgroundColor: "#489dbeff",
                      padding: "3px",
                      color: "white",
                      borderRadius: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      marginTop: "20px",
                    }}
                  >
                    Continue
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingLeft: "10%",
                paddingRight: "10%",
                height: "80%",
                width: "100%",
                background:
                  "linear-gradient(360deg, #ffffffff, #cac8c8ff, #c5c3c3ff)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "15px",
                  borderTopLeftRadius: "10px",
                  borderBottomLeftRadius: "10px",
                  background:
                    "linear-gradient(180deg, #ffffffff, #b9b9b9ff, #7e7d7dff)",
                  maxHeight: "100%",
                  overflowY: "auto",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  width: "50%",
                }}
              >
                <p
                  style={{
                    width: "50%",
                    fontSize: "18px",
                    fontWeight: "700",
                    padding: "10px",
                  }}
                >
                  Select Seats
                </p>
                <div
                  style={{
                    width: "250px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "15px",
                    padding: "15px",
                    borderRadius: "15px",
                    boxShadow: "0 0 10px 2px rgba(94, 36, 36, 0.3)",
                    backgroundColor: "#c5e9fdff",
                  }}
                >
                  {selectedBus.seatConfiguration.busType === "2*2" ? (
                    Array.from({
                      length: selectedBus.seatConfiguration?.rows || 0,
                    }).map((_, ind) => (
                      <TwoCrossTwo
                        col={ind * selectedBus.seatConfiguration?.columns}
                      />
                      //<OneCrossTwo start={item} end={item+selectedBus.seatConfiguration?.column}/>
                    ))
                  ) : selectedBus.seatConfiguration.busType === "1*2" ||
                    "2*1" ? (
                    Array.from({
                      length: selectedBus.seatConfiguration?.rows || 0,
                    }).map((_, ind) => (
                      <OneCrossTwo
                        col={ind * selectedBus.seatConfiguration?.columns}
                      />
                      //<OneCrossTwo start={item} end={item+selectedBus.seatConfiguration?.column}/>
                    ))
                  ) : selectedBus.seatConfiguration.busType === "3*2" ||
                    "2*3" ? (
                    Array.from({
                      length: selectedBus.seatConfiguration?.rows || 0,
                    }).map((_, ind) => (
                      <TwoCrossThree
                        col={ind * selectedBus.seatConfiguration?.columns}
                      />
                      //<OneCrossTwo start={item} end={item+selectedBus.seatConfiguration?.column}/>
                    ))
                  ) : selectedBus.seatConfiguration.busType === "1*3" ||
                    "3*1" ? (
                    Array.from({
                      length: selectedBus.seatConfiguration?.rows || 0,
                    }).map((_, ind) => (
                      <OneCrossThree
                        col={ind * selectedBus.seatConfiguration?.columns}
                      />
                      //<OneCrossTwo start={item} end={item+selectedBus.seatConfiguration?.column}/>
                    ))
                  ) : (
                    <div>No seat configuration available</div>
                  )}

                  <div style={{ display: "flex" }}>
                    {Array.from({
                      length: selectedBus.seatConfiguration.back,
                    }).map((_, index) => (
                      <div
                        style={{ padding: "6px", cursor: "pointer" }}
                        onClick={() => handleBackSeatSelection(index + 1)}
                      >
                        <img
                          src={`${selectedBackSeats.includes(index + 1) ? "/Assets/seat-2.png" : "/Assets/seat-1.png"}`}
                        />
                        <p style={{ fontSize: "8px", color: "gray" }}>₹ 150</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div
                style={{
                  background:
                    "linear-gradient(180deg, #ffffffff, #b9b9b9ff, #7e7d7dff)",
                  minHeight: "100%",
                  borderLeft: "1px solid gray",
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "start",
                  gap: "30px",
                  borderTopRightRadius: "10px",
                  borderBottomRightRadius: "10px",
                }}
              >
                <div>
                  <div
                    style={{
                      borderBottom: "0.4px solid gray",
                      cursor: "pointer",
                    }}
                  >
                    <p
                      onClick={() => {
                        modalMode === "routes"
                          ? setModalMode("")
                          : setModalMode("routes");
                      }}
                      style={{
                        fontSize: "22px",
                        padding: "20px",
                        fontWeight: "700",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>Show Routes</span>
                      <span>
                        {modalMode === "routes" ? (
                          <img
                            src="/Assets/arrow-up.png"
                            style={{ width: "20px" }}
                          />
                        ) : (
                          <img
                            src="/Assets/down-arrow.png"
                            style={{ width: "20px" }}
                          />
                        )}
                      </span>
                    </p>
                    {/* {
                  modalMode==="routes" && 
                  <div style={{display:"flex",flexDirection:"column",maxHeight:"200px",overflowY:"auto",scrollbarWidth: "none", msOverflowStyle: "none",padding:"10px"}}>
                    {routesPoints.map((item)=>(
                      <p style={{display:'flex',justifyContent:"space-between",paddingBottom:"16px",fontWeight:"300",paddingLeft:"20px"}}>
                        <span style={{width:"10px",height:"10px",borderRadius:"50%",backgroundColor:"#25faa8ff"}}></span>
                        <span>{item.point}</span><span>{item.time}</span></p>
                    ))

                    }

                  </div>
                } */}
                  </div>
                  <div
                    style={{
                      borderBottom: "0.4px solid gray",
                      cursor: "pointer",
                    }}
                  >
                    <p
                      onClick={() => {
                        modalMode === "pickup"
                          ? setModalMode("")
                          : setModalMode("pickup");
                      }}
                      style={{
                        fontSize: "22px",
                        padding: "20px",
                        fontWeight: "700",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>Select Pickup-points</span>
                      <span>
                        {modalMode === "pickup" ? (
                          <img
                            src="/Assets/arrow-up.png"
                            style={{ width: "20px" }}
                          />
                        ) : (
                          <img
                            src="/Assets/down-arrow.png"
                            style={{ width: "20px" }}
                          />
                        )}
                      </span>
                    </p>
                    {modalMode === "pickup" && (
                      <div
                        style={{
                          padding: "10px",
                          border: "0.4px solid gray",
                          borderRadius: "10px",
                          margin: "12px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                        }}
                      >
                        <p style={{ fontWeight: "600" }}>Pickup Points</p>

                        {selectedBus.route?.additionalBoardingPoints.map(
                          (i) => (
                            <div
                              onClick={() => setBoardingPoint(i._id)}
                              style={{
                                padding: "8px",
                                width: "70%",
                                height: "80px",
                                borderBottom: "0.3px solid gray",
                                fontSize: "12px",
                                backgroundColor:
                                  boardingPoint === i._id
                                    ? "#adf8e2ff"
                                    : "white",
                                borderRadius: "10px",
                              }}
                            >
                              <p>{i.name}</p>
                              <p>{i.pickupTime}</p>
                              <p>{i.address}</p>
                              <p>{i.city}</p>
                            </div>
                          ),
                        )}
                      </div>
                    )}
                  </div>

                  <div style={{ cursor: "pointer" }}>
                    <p
                      onClick={() => {
                        modalMode === "dropping"
                          ? setModalMode("")
                          : setModalMode("dropping");
                      }}
                      style={{
                        fontSize: "22px",
                        padding: "20px",
                        fontWeight: "700",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>Select Drop-points</span>
                      <span>
                        {modalMode === "dropping" ? (
                          <img
                            src="/Assets/arrow-up.png"
                            style={{ width: "20px" }}
                          />
                        ) : (
                          <img
                            src="/Assets/down-arrow.png"
                            style={{ width: "20px" }}
                          />
                        )}
                      </span>
                    </p>
                    {modalMode === "dropping" && (
                      <div
                        style={{
                          padding: "10px",
                          border: "0.4px solid gray",
                          borderRadius: "10px",
                          margin: "12px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                        }}
                      >
                        <p style={{ fontWeight: "600" }}>Dropping Points</p>

                        {selectedBus.route?.additionalDroppingPoints.map(
                          (i) => (
                            <div
                              onClick={() => setDroppingPoint(i._id)}
                              style={{
                                padding: "8px",
                                width: "70%",
                                height: "80px",
                                borderBottom: "0.3px solid gray",
                                fontSize: "12px",
                                backgroundColor:
                                  droppingPoint === i._id
                                    ? "#adf8e2ff"
                                    : "white",
                                borderRadius: "10px",
                              }}
                            >
                              <p>{i.name}</p>
                              <p>{i.dropTime}</p>
                              <p>{i.address}</p>
                              <p>{i.city}</p>
                            </div>
                          ),
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div
                  style={{
                    padding: "10px",
                    borderRadius: "10px",
                    margin: "6px",
                    backgroundColor: "white",
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>
                      <p style={{ fontWeight: "700" }}>Selected Seats</p>
                      <p>{selectedSeats.length + selectedBackSeats.length}</p>
                    </div>
                    <div>
                      <p>
                        {selectedBus.basePrice *
                          (selectedSeats.length +
                            selectedBackSeats.length)}{" "}
                        /-
                      </p>
                      <p style={{ color: "#489dbeff", fontWeight: "700" }}>
                        Fare Details
                      </p>
                    </div>
                  </div>
                  <p
                    onClick={handleConfirmBooking}
                    style={{
                      width: "100%",
                      backgroundColor: "#489dbeff",
                      padding: "3px",
                      color: "white",
                      borderRadius: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      marginTop: "20px",
                    }}
                  >
                    Continue
                  </p>
                </div>
              </div>
            </div>
          )}
        </motion.div>
      )}
      <Footer />
    </>
  );
};

export default BusBooking;
